import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Minimum length (after trimming) of the free-text reason an admin must
 * supply when creating a manual payout order. Kept here so the client and
 * server share the same source of truth.
 */
export const MANUAL_PAYOUT_ORDER_REASON_MIN_LENGTH = 25;

export const createManualPayoutOrder = {
  name: "createManualPayoutOrder" as const,
  input: z.object({
    teamId: zExt.objectId(),
    amount: z.number(),
    currency: z.nativeEnum(Currency).optional(),
    chargeType: z.string(),
    returnId: zExt.objectId().optional(),
    orderId: zExt.objectId().optional(),
    reason: z
      .string()
      .transform((value) => value.trim())
      .refine(
        (value) => value.length >= MANUAL_PAYOUT_ORDER_REASON_MIN_LENGTH,
        `Reason must be at least ${MANUAL_PAYOUT_ORDER_REASON_MIN_LENGTH} characters`,
      ),
    payoutId: zExt.objectId().optional(),
  }),
  output: z.object({ payoutOrderId: zExt.objectId(), success: z.boolean() }),
};
